import type { AvailableFiltersItemProps } from '@services/api/preview/types'

const isTodosOption = (item: AvailableFiltersItemProps) =>
  item.code?.toLowerCase() === 'all' || item.name?.toLowerCase() === 'todos'

// Retorna a única opção real (desconsiderando o "Todos") quando a lista só tem uma; senão, null
export const getSingleFilterOption = (options?: AvailableFiltersItemProps[]) => {
  const realOptions = (options ?? []).filter((item) => !isTodosOption(item))

  return realOptions.length === 1 ? realOptions[0] : null
}

// Valor neutro do filtro: a opção "Todos" quando ela existe na lista
export const getTodosFilterValue = (options?: AvailableFiltersItemProps[]): string[] => {
  const todosOption = (options ?? []).find(isTodosOption)

  return todosOption ? [todosOption.code] : []
}
